import { Route, Routes } from "react-router-dom";
import { CreateInvoicePage } from "../../pages/invoice/create-invoice.page";
import { UpdateInvoicePage } from "../../pages/invoice/update-invoice.page";
import { ListInvoicesPage } from "../../pages/invoice/list-invoices.page";
import { ACCESS_RULES } from "../../shared/auth/access-control";
import RoleProtectedRoute from "../protected/role-protected-route.component";

const InvoiceRoutes = () => {
  return (
    <Routes>
      <Route path="/create" element={<RoleProtectedRoute allowedRoles={ACCESS_RULES.INVOICES}><CreateInvoicePage /></RoleProtectedRoute>} />
      <Route path="/list" element={<RoleProtectedRoute allowedRoles={ACCESS_RULES.INVOICES}><ListInvoicesPage /></RoleProtectedRoute>} />
      <Route path=":invoiceID" element={<RoleProtectedRoute allowedRoles={ACCESS_RULES.INVOICES}><UpdateInvoicePage /></RoleProtectedRoute>} />
    </Routes>
  );
};

export default InvoiceRoutes;
